import React from 'react'

function WorkerSelection({ workers, onWorkerSelect, selectedWorker }) {
  const anyWorkerOption = {
    id: 'any',
    name: 'Any Available Stylist',
    specialty: 'Let us choose the best stylist for you'
  }

  return (
    <div className="booking-step">
      <h2>Choose Your Worker</h2>
      <div className="workers-grid">
        {workers.length > 1 && (
          <div
            key="any"
            className={`worker-card any-worker-card ${selectedWorker?.id === 'any' ? 'selected' : ''}`}
            onClick={() => onWorkerSelect(anyWorkerOption)}
          >
            <div className="worker-image any-worker-image">
              <span>ANY</span>
            </div>
            <h3>{anyWorkerOption.name}</h3>
            <p>{anyWorkerOption.specialty}</p>
          </div>
        )}

        
        {workers.map((worker) => (
          <div
            key={worker.id}
            className={`worker-card ${selectedWorker?.id === worker.id ? 'selected' : ''}`}
            onClick={() => onWorkerSelect(worker)}
          >
            <h3>{worker.name}</h3>
          </div>
        ))}
      </div>
    </div>
  )
}

export default WorkerSelection